var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
var Thumbnail = /** @class */ (function (_super) {
    __extends(Thumbnail, _super);
    function Thumbnail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = _this.getImage();
        return _this;
    }
    Thumbnail.prototype.getImage = function () {
        var _a = this.props, cid = _a.cid, item_id = _a.item_id, alt = _a.alt, size = _a.size, seq = _a.seq;
        var dir = Math.ceil(parseInt(item_id.toString(), 10) / 1000) * 1000;
        var imgUrl = "".concat(process.env.REACT_APP_CDN_IMG, "/img_shopping/img_goods/img_") + dir + '/img_' + item_id;
        var callCateID = cid.toString();
        if (cid.toString().substr(0, 1) === '2') {
            callCateID = '2010000000';
        }
        var noImgUrl = "".concat(process.env.REACT_APP_CDN_IMG, "/img_shopping/img_goods/img_no/") + callCateID;
        return this.itemImage({ imgUrl: imgUrl, noImgUrl: noImgUrl }, alt, size, seq);
    };
    Thumbnail.prototype.itemImage = function (thumbnail, alt, size, seq) {
        alt = alt ? alt : '';
        var src = thumbnail.imgUrl;
        var err = thumbnail.noImgUrl;
        var getSeq = (seq && seq !== '0' && seq !== 0) ? '.' + seq : '';
        if (size === undefined || size === '') {
            src = src + '/200' + getSeq + '.jpg';
            err = err + '_500.png';
        }
        else {
            src = src + '/' + size + getSeq + '.jpg';
            err = err + '_500.png';
        }
        err = "".concat(process.env.REACT_APP_CDN_IMG, "/img_shopping/img_goods/img_no/no_item_img.jpg");
        return { src: src, err: err, alt: alt };
    };
    Thumbnail.prototype.itemImageError = function (e, err) {
        if (e.target.src.indexOf(err) === -1) {
            // e.target.src = err
            e.target.src = "".concat(process.env.REACT_APP_CDN_IMG, "/img_shopping/img_goods/img_no/no_item_img.jpg");
        }
    };
    Thumbnail.prototype.render = function () {
        var _this = this;
        var _a = this.state, src = _a.src, err = _a.err, alt = _a.alt;
        return (React.createElement("img", { src: src, onError: function (e) { return _this.itemImageError(e, err); }, alt: alt }));
    };
    return Thumbnail;
}(React.Component));
export default Thumbnail;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/catalog/thumbnail.tsx
// module id = 236
// module chunks = 0